<template>
  <RevCard class="p-24">
    <div class="flex">
      <div
        class="border-static-default-low rounded-sm flex h-40 w-40 items-center justify-center border"
      >
        <RevIllustration
          :alt="title"
          class="h-32 w-32"
          data-qa="product-picture"
          data-test="product-picture"
          :height="32"
          :src="image"
          :width="32"
        />
      </div>
      <div class="ml-16 w-full">
        <div class="space-y-8">
          <div class="flex justify-between gap-24">
            <h2
              class="body-2-bold"
              data-qa="product-name"
              data-test="product-name"
            >
              {{ title }}
            </h2>
            <div class="body-2">
              {{ i18n(translations.replacementOrderFree) }}
            </div>
          </div>

          <div class="body-2 flex">
            <div>{{ i18n(translations.replacementOrderShipping) }}</div>
          </div>
          <p
            class="text-static-default-low body-2"
            data-qa="product-delivery-window"
            data-test="product-delivery-window"
          >
            {{ deliveryRange }}
          </p>
        </div>
      </div>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { DateDate } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'

import { DATE_FORMAT_DELIVERY } from './XrReplacementOrderSummary.constants'
import translations from './XrReplacementOrderSummary.translations'

interface XrReplacementOrderSummaryProps {
  title: string
  image: string
  deliveryDatesWindow: {
    min: DateDate
    max: DateDate
  }
}

const { deliveryDatesWindow } = defineProps<XrReplacementOrderSummaryProps>()

const i18n = useI18n()

const deliveryRange = computed(() =>
  i18n(translations.replacementOrderDeliveryRange, {
    min: i18n.date(new Date(deliveryDatesWindow.min), DATE_FORMAT_DELIVERY),
    max: i18n.date(new Date(deliveryDatesWindow.max), DATE_FORMAT_DELIVERY),
  }),
)
</script>
